import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import CheckoutView from '../views/CheckoutView.vue';

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/checkout/:id', name: 'checkout', component: CheckoutView },
  { path: '/success',  name: 'success',  component: () => import('../views/SuccessView.vue') },
  { path: '/ebook/:id', name: 'LivroDetalhes',  component: () => import('@/views/DetailEbook.vue'), props: true },
  { path: '/ebooks', name: 'GaleriaEbooks',  component: () => import('@/views/LibraryView.vue')},
  { path: '/login', component: () => import('../views/Login.vue'), meta: { hideLayout: true } },
  { path: '/admin',alias: '/admin/',   name: 'Admin',  component: () => import('../views/admin/adminPanel.vue'), meta: { requiresAuth: true,hideLayout: true } }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth', // Isso ativa o scroll suave automaticamente
      }
    }
    return { top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('admin_token');

  if (to.meta.requiresAuth && !isAuthenticated) {
    // Se tentar entrar no admin sem estar logado, manda pro login
    next('/login');
  } else {
    next();
  }
});

export default router;